export const VALID_APARTMENT_TYPES = ['studio-sea', '1br-sea', '1br-panoramic'] as const;
export type ApartmentTypeId = (typeof VALID_APARTMENT_TYPES)[number];

export const TYPE_CAPACITY: Record<ApartmentTypeId, number> = {
  'studio-sea': 3,
  '1br-sea': 5,
  '1br-panoramic': 5,
};
